// @ts-strict-ignore
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LMModel, LMModelServiceAdapter } from './model';
import { LMButtonEvent, LMFieldSubscriptionService, LMGenAIEvent, LMTextEvent } from '@field/index';
import { LMFormState } from '@states/models';
import { TemplateRecordInfo } from './lm-form-content-template.component';
import { LMFormatUtilService, LMLoggerService } from '@services/index';
import { AppConstants, LMGlobalUtilService } from '@utils/index';
import * as urltemplate from 'url-template';
import { LMNavigationService } from '@navigation/lm-navigation.service';
import { first } from 'rxjs/operators';
import { GenAIPromptDialogResult, GenAIPromptDialogStatus, LMGenAIPromptDialogService } from '@app/components';

@Component({
  selector: 'lm-template-form-record',
  providers: [
    LMFieldSubscriptionService,
    LMModelServiceAdapter,
    LMGenAIPromptDialogService
  ],
  template: `
    <lm-form-content-form #LMFormStandardComponent
      *ngIf="formSpec"
      [formSpec]="formSpec"
      [formOptions]="formOptions"
      [isTemplateForm]="true"
      [specFields]="specFields"
      [layout]="layout"
      [model]="info.model"
      (fieldEvent)="onFieldEvent($event)"
    ></lm-form-content-form>`
})

export class LMTemplateFormRecordComponent {
  @Input() info: TemplateRecordInfo;
  @Input() formUrlInfo: LMFormUrlInfo;
  @Input() formSpec: LMFormSpec;
  @Input() formOptions: LMFormOptions = null;

  @Input() specFields: LMSpecFields;
  @Input() layout: LMFormLayout;
  @Input() model: LMModel;
  @Input() formState: LMFormState;

  @Output() templateFieldEvent: EventEmitter<LMFieldEvent> = new EventEmitter<LMFieldEvent>();

  constructor(
    private lmFormatUtilService: LMFormatUtilService,
    private lmGlobalUtilService: LMGlobalUtilService,
    private lmNavigationService: LMNavigationService,
    private lmLoggerService: LMLoggerService,
    private lmGenAIPromptDialogService: LMGenAIPromptDialogService
  ) {
  }

  onFieldEvent(event) {
    if ('ButtonEvent' === event.eventType) {
      const buttonEvent = event as LMButtonEvent;
      this.runFormButtonAction(buttonEvent.layoutObject);
      return;
    }

    if ('TextLinkEvent' === event.eventType) {
      const linkEvent = event as LMTextEvent;
      if (linkEvent.layoutObject.hasHttpUrl || linkEvent.layoutObject.linkNavigation) {
        this.buildFormTextLinkNavigation(linkEvent.layoutObject);
      } else {
        this.runFormButtonAction(linkEvent.layoutObject);
      }
      return;
    }
    if ('GenAIEvent' === event.eventType) {
      const genAIEvent = event as LMGenAIEvent;
      this.openGenAPromptIDialog(genAIEvent.fieldId, genAIEvent.fieldLabel);
      return;
    }

    this.templateFieldEvent.emit(event);

    this.lmLoggerService.error([ 'lm-template-form-record: unsupported event', event ]);
  }

  // TODO: same as LMFormComponent; need a common service
  private runFormButtonAction(formButton: LMButtonLayout) {
    switch (formButton.type) {
      // case AppConstants.BUTTON_TYPE_ACTION:
      //   this.runAction(formButton.actionSpec);
      //   break;

      case AppConstants.BUTTON_TYPE_NAVIGATION:
        this.runNavigation(formButton.navigation, formButton.showAsPdf);
        break;

        // case AppConstants.BUTTON_TYPE_LIST_REFERENCE:
        //   // TODO:
        //   break;
        //
        // case AppConstants.BUTTON_TYPE_RELATED:
        //   this.runButtonRelatedAction(formButton.relActionUrl, formButton.name);
        //   break;
        //
        // case AppConstants.BUTTON_TYPE_FORMINVOKE:
        //   // just need form url and csk params. no other params are required for a form invoke.
        //   let formUrl = this.lmUrlUtilService.buildUrl({
        //     context: this.formSpec.context,
        //     resource: this.formResource
        //   });
        //   this.lmNavigationService.runFormInvoke(formUrl, formButton.formInvokeName, this.model.getData());
        //   break;

      case AppConstants.BUTTON_TYPE_HTTPURL:
        const option: string = (formButton.openExternal) ? 'external' : '';
        const url: string = this.lmFormatUtilService.formatMessageRule(formButton.httpUrl, this.info.model.getData());

        if (url) {
          this.lmGlobalUtilService.navigate(url, null, option);
        }
        break;

        // case AppConstants.BUTTON_TYPE_SUBFORM:
        //   // TODO:
        //   break;
        //
        // case AppConstants.BUTTON_TYPE_VIEWDOCUMENT:
        // case AppConstants.BUTTON_TYPE_SHOWEDITOR:
        //   this.openDocumentResource(formButton);
        //   break;
        // case AppConstants.BUTTON_TYPE_EXPORTDOCUMENT:
        //   // TODO:
        //   break;

      default:
        this.lmLoggerService.error([ 'lm-template-form-record: unsupported button action', formButton ]);
        break;
    }
  }

  private openGenAPromptIDialog(fieldId: string, fieldLabel: string): void {
    this.lmGenAIPromptDialogService.promptGenAIDialog(this.formUrlInfo.formRequestUrl, fieldId, this.model, fieldLabel)
    .pipe(first())
    .subscribe((result: GenAIPromptDialogResult) => {
      if (result.status !== GenAIPromptDialogStatus.RESPONSE_OK) {
        return;
      }
      this.lmLoggerService.log(result.generated);
      this.model.updateModelFromGenAI(result.dataView, result.model, result.fieldId, result.generated);
    });
  }

  // TODO: same as LMFormComponent; need a common service
  private buildFormTextLinkNavigation(link: LMButtonLayout) {
    if (link.httpUrl) {
      const option: string = (link.openExternal) ? 'external' : '';
      const url: string = this.lmFormatUtilService.formatMessageRule(link.httpUrl, this.info.model.getData());

      if (url) {
        this.lmGlobalUtilService.navigate(url, null, option);

      }
    } else if (link.linkNavigation) {
      this.runNavigation(link.linkNavigation, link.showAsPdf);

    }
  }

  // TODO: same as LMFormComponent; need a common service
  private runNavigation(navigation: string, showAsPdf: boolean) {
    const compiledTemplateNavUrl = urltemplate.parse(this.formUrlInfo.navigationUrl);
    const navigationUrl = compiledTemplateNavUrl.expand({
      resourceId:     this.info.model.resourceId,
      navigationName: navigation
    });
    this.lmNavigationService.runNavigation(navigationUrl, undefined, { showAsPdf });
  }
}
